$(document).ready(function(){
    $('.js-click-event').on('click', function(){
        sendGAEvent('click', $(this).data('category'), $(this).data('label'));
    });
});

function sendGAEvent(action, category, label){
    if(typeof gtag !== 'undefined'){
        console.log(action+'-'+category+'-'+label);
        gtag('event', action, { 'event_category': category, 'event_label': label });
    }
  }

window.addEventListener('scroll', event => {
    if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        $('.header').addClass('reduced');
    } else {
        //$('.header').removeClass('reduced');

    }
}, {passive: true});

$(document).ready(function(){
    if($('.car-form').length > 0){
        $(window).scroll(function() {
            var vpWidth = $(document).width();
            if (vpWidth > 1200) {
                var winTop = $(window).scrollTop();
            var pageContentTop = $('.main-c').offset().top - 120;

            var mainH = $('#interna-page > .container').height();
            var sidebarH = $('.side-c').height();

            var mainSideDiff = mainH - sidebarH + 20; // 20 = main margin-bottom
            var stopPointBottom = pageContentTop + (mainSideDiff);

            if(winTop > pageContentTop && winTop < stopPointBottom) {
                var diff = winTop - pageContentTop;
                diff = diff - 20;
                if(diff < 0){ diff = 0; }
                $('.car-form').css('top', diff); // 10 = to give some space from top
            } else if(winTop > stopPointBottom) {


                $('.car-form').css('top', mainSideDiff -110);
            } else {
                $('.car-form').css('top', 0);
            }
            }
        });
    }
    $('.main-slider-desktop').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots:true,
        fade: false,
        adaptiveHeight: true,
        lazyLoad: 'progressive'
    });

    $('.main-slider-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows: true,
        fade: false,
        adaptiveHeight: true,
        lazyLoad: 'progressive'
    });

    $('.galeria-carro').slick({
        slidesToShow: 1 ,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        fade: false,
        adaptiveHeight: true,
        lazyLoad: 'progressive',
        mobileFirst: true,
        asNavFor: ".galeria-nav",

    });
    $('.galeria-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: false,
        adaptiveHeight: true,
        lazyLoad: 'progressive',

        asNavFor: ".galeria-carro",
        focusOnSelect: true,

    });


    $('.galeria-video').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        adaptiveHeight: true,
        lazyLoad: 'progressive',
        mobileFirst: true,
    });

    $('.estoque-slick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        adaptiveHeight: true,
        lazyLoad: 'progressive',
        mobileFirst: true,
        responsive:[
            {
                breakpoint:764,
                settings:"unslick"
            }
        ]
    });

    $(".year").mask("9999");
	$(".data").mask("99/99/9999");
	$(".cep").mask("99999-999");
	$(".cpf").mask("999.999.999-99");
	$(".placa_carro").mask("aaa-9999");
	$('.phone-mask')
            .mask("(99)9999-9999?9", { placeholder: "" })
            .blur(function (event) {
                var target, phone, element;
		target = (event.currentTarget) ? event.currentTarget : event.srcElement;
		phone = target.value.replace(/\D/g, '');
		element = $(target);
		element.unmask();
		if(phone.length > 10) {
			element.mask("(99)99999-999?9", { placeholder: "" });
		} else {
			element.mask("(99)9999-9999?9", { placeholder: "" });
		}
    });

    $('.money').maskMoney({
		prefix: 'R$ ',
		thousands: '',
		decimal: '',
		precision: 0,
		allowZero: false,
		affixesStay: false
	});

    $('.lojas-mapa .js-showmap').on('click', function(){

        var id = $(this).data('map_id');
        $('.js-showmap').removeClass('active');
        $(this).addClass('active');
        $('.map-content').removeClass('active');
        $('.map-content.map-content-'+id).addClass('active');
        return false;
    });

    $(".btn-menu-mobile").click(function () {
        if ($(this).hasClass('open')) {
            closeMenu();
            history.back();
        } else {
            openMenu();
            window.history.pushState({menu: 'open'}, "Menu", "#menu");
        }
    });

    $(".menu-tel").click(function () {
        if ($(this).hasClass('open')) {
            closeContact();
            history.back();
        } else {
            openContact();
            window.history.pushState({menu: 'open'}, "Menu", "#menu");
        }
    });

    $('.btn-interesse').on('click', function(){
       $('.modal').find('input[name="id_carro_seminovo"]').val($(this).data('id_veiculo'));
    });

});

function myFunction(x) {
    x.classList.toggle("change");
}


function openMenu(){
    $(".btn-menu-mobile").addClass('open');
    $(".menu-top").addClass("menu-show");
    $("body").addClass("block-overflow");
    $(".menu-overlay").addClass("show");
}

function closeMenu(){
    $(".btn-menu-mobile").removeClass('open');
    $(".menu-top").removeClass("menu-show");
    $("body").removeClass("block-overflow");
    $(".menu-overlay").removeClass("show");
}

function openContact(){
    $(".menu-tel").addClass('open');
    $(".menu-contact-top").addClass("menu-show");
    $("body").addClass("block-overflow");
    $(".menu-overlay").addClass("show");
}

function closeContact(){
    $(".menu-tel").removeClass('open');
    $(".menu-contact-top").removeClass("menu-show");
    $("body").removeClass("block-overflow");
    $(".menu-overlay").removeClass("show");
}

var kmveiculo = document.getElementById('kmveiculo');
var anoveiculo = document.getElementById('anoveiculo');
var valorveiculo = document.getElementById('valorveiculo');

if($(kmveiculo).length){
    noUiSlider.create(kmveiculo, {
        range: {
            'min': 0,
            'max': 100000
        },
        step: 1,
        start: [0, 100000],
        margin: 0,
        connect: true,
        format: {
            to: function ( value ) {
                return parseInt(value);
            },
            from: function ( value ) {
                return parseInt(value);
            }
        },
        behaviour: 'tap-drag',
        tooltips: true
    });

    kmveiculo.noUiSlider.on('update', function (values, handle) {
        $('#slider-km_' + handle).val(values[handle]);
        $('#slider-km-range').html(values.join(' até '));
    });
}

if($(anoveiculo).length){
    noUiSlider.create(anoveiculo, {
        range: {
            'min': 1988,
            'max': 2022
        },
        step: 1,
        start: [2010, 2022],
        margin: 0,
        connect: true,
        format: {
            to: function ( value ) {
                return parseInt(value);
            },
            from: function ( value ) {
                return parseInt(value);
            }
        },
        behaviour: 'tap-drag',
        tooltips: false
    });

    anoveiculo.noUiSlider.on('update', function (values, handle) {
        $('#slider-ano_' + handle).val(values[handle]);
        $('#slider-ano-range').html(values.join(' até '));
    });
}

if($(valorveiculo).length){

    noUiSlider.create(valorveiculo, {
        range: {
            'min': [15000],
            '70%': [700000],
            'max': [1000000]
        },
        step: 5000,

        start: [15000, 300000],
        connect: true,

        format: {
            to: function ( value ) {
                return parseInt(value);
            },
            from: function ( value ) {
                return parseInt(value);
            }
        },

        behaviour: 'tap-drag',
        tooltips: false
    });
    valorveiculo.noUiSlider.on('update', function (values, handle) {
        $('#slider-valor_' + handle).val(values[handle]);
        values[0] = "R$ " + values[0].toLocaleString("pt-BR");
         if(values[1] == valorMax){
            values[1] = valorMaxLabel;
        }else{
            values[1] = "R$ " + values[1].toLocaleString("pt-BR");
        }
        $('#slider-valor-range').html(values.join(' - '));
    });
}



$('.enviar').removeAttr('disabled');

$('.form-ajax').ajaxForm({
    dataType: 'json',
    beforeSubmit: function(arr, $form, options){
        $('.enviar').attr('disabled','disabled');
        startLoading();
    },
    success: function(json, status, xhr, form) {
        var id_form = form[0].id;

        if(json.erro != ""){
            sendGAEvent('generate_lead', 'lead_error',  json.erro);
            swal({html:true, title:'Falha no envio', text:json.erro, type:'error'});
        }else{
            sendGAEvent('generate_lead', 'lead', id_form);
            swal({html:true, title:'Enviado com sucesso!', text:json.sucesso, type:'success'});
            $(form)[0].reset();
        }


        // $(".js-form-content").fadeOut()
        // $(".js-form-confirmation").fadeIn()
    },
    error: function(e) {
        console.log(e);
        swal('Erro ao processar formulário', 'Tente novamente mais tarde.', 'error');
    },
    complete: function(){
        $('.enviar').removeAttr('disabled');
        stopLoading();
    }

});

function startLoading(){
  	$('.loading-wrapper').stop(true, true).fadeIn();
}

function stopLoading(){
  	$('.loading-wrapper').stop(true, true).fadeOut('fast');
}

$('body').on('change', '.select-marca', function() {
  console.log("marca 1");
  var id_marca = $(this).val();
  var $this = $(this);
  carregarModelos(id_marca, $this);
});

if($('.select-marca').length > 0) {
  $('.select-marca').each(function(index) {
    console.log("marca 2");
    var id_marca = $(this).val();
    var $this = $(this);
    if($this.closest('form').find('.select-modelo').children().length <= 1){
      carregarModelos(id_marca, $this);
    }
  });
}


function carregarModelos(id_marca, $this){
    if(id_marca != "" && id_marca > 0){
        $.ajax({
            url: base_url + 'lua4auto/seminovosmodelos/busca/'+id_marca,
            type: 'get',
            beforeSend: function(){
                $this.closest('form').find('.select-modelo').html('<option value="0">Selecione primeiro uma marca</option>');
                startLoading();
            },
            dataType: 'json',
            success: function(json){
                var html = '<option value="">Selecione um modelo</option>';
                $.each(json, function(key, value) {
                    if($this.hasClass('marca-busca')){
                        if(value.qtd_carros > 0){
                            html += '<option value="'+value.id_modelo+'">'+value.descricao+'</option>';
                        }
                    }else{
                        html += '<option value="'+value.id_modelo+'">'+value.descricao+'</option>';
                    }
                });
                $this.closest('form').find('.select-modelo').html(html);
            },
            complete: function(){
                stopLoading();
            }
        });
    }
}
